import React, { useState, forwardRef, useImperativeHandle } from "react";
import { parseBankStatement } from "./BankStatementParser";
import LoaderComponent from "../../PageComponents/UI/Components/LoaderComponent";

const BankImportUpload = forwardRef(({ bankType, onDataParsed, lengthMessage }, ref) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useImperativeHandle(ref, () => ({
        reset() {
            setError('');
            setLoading(false);
        }
    }));

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!bankType) {
            setError('Zgjidhni tipin e bankës lart');
            e.target.value = '';
            return;
        }

        setLoading(true);
        setError('');

        try {
            const transactions = await parseBankStatement(file, bankType.value);

            if (!transactions || transactions.length === 0) {
                setError('Nuk u gjetën transaksione. Kontrolloni formatin.');
                setLoading(false);
                e.target.value = '';
                return;
            }

            const numbered = transactions.map((t, i) => ({ ...t, no: i + 1 }));
            const headers = ['no', 'date', 'description', 'reference', 'debit', 'credit'];
            onDataParsed(headers, numbered);
        } catch (err) {
            console.error('Parse error:', err);
            setError('Gabim: ' + (err.message || 'Formati nuk u njoh'));
        } finally {
            setLoading(false);
            e.target.value = '';
        }
    };

    return (
        <div className="bank-import-upload">
            {loading ? (
                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <LoaderComponent />
                    <span style={{ fontSize: '11px', color: '#858796' }}>Duke lexuar...</span>
                </div>
            ) : (
                <label
                    className="mb-0"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        padding: '4px 11px',
                        fontSize: '12px',
                        fontWeight: 500,
                        color: '#fff',
                        background: '#4e73df',
                        border: '1.5px solid #4e73df',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        lineHeight: 1.4,
                        userSelect: 'none',
                        transition: 'background .15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#3d5fc4'}
                    onMouseLeave={e => e.currentTarget.style.background = '#4e73df'}
                >
                    <i className="fas fa-file-pdf" style={{ fontSize: '12px', color: '#fca5a5' }} />
                    <i className="fas fa-file-excel" style={{ fontSize: '12px', color: '#86efac' }} />
                    <span style={{ width: '1px', height: '12px', background: 'rgba(255,255,255,0.35)', display: 'inline-block', margin: '0 1px' }} />
                    <span style={{ fontSize: '12px' }}>Ngarko</span>
                    <input
                        type="file"
                        accept=".xlsx,.xls,.pdf,.csv"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />
                </label>
            )}
            {error && <p className="text-danger small mb-0 mt-1" style={{ fontSize: '11px' }}>{error}</p>}
            {lengthMessage && <p className="text-danger small mb-0" style={{ fontSize: '11px' }}>{lengthMessage}</p>}
        </div>
    );
});

export default BankImportUpload;
